import React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

/** App-wide theme provider — class strategy (tailwind darkMode: ["class"]).
 *  Persists the choice in localStorage; "system" follows the OS preference. */
export default function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
